import { type Product } from '../../../lib/supabase';

interface TrendingSidebarProps {
  products: Product[];
}

export function TrendingSidebar({ products }: TrendingSidebarProps) {
  const trending = products
    .filter(p => p.trending)
    .slice(0, 5);

  return (
    <div className="space-y-5">
      {/* Trending Now */}
      <div className="bg-white border border-gray-100 shadow-sm p-4">
        <h3 className="text-xs font-bold text-gray-900 uppercase tracking-wider mb-3 flex items-center gap-1.5">
          <i className="ri-fire-fill text-amber-500 text-sm"></i> Trending Now
        </h3>
        <div className="space-y-3">
          {trending.map((p, idx) => (
            <div key={p.id} className="flex items-center gap-3">
              <span className="text-xs font-bold text-gray-300 w-4 flex-shrink-0">{idx + 1}</span>
              <div className="w-8 h-8 overflow-hidden bg-gray-100 flex-shrink-0">
                <img src={p.logo} alt={p.name} className="w-full h-full object-cover" />
              </div>
              <div className="min-w-0">
                <div className="text-xs font-semibold text-gray-900 truncate">{p.name}</div>
                <div className="text-[10px] text-gray-400">{p.category}</div>
              </div>
              <span className="ml-auto text-[10px] text-gray-400 whitespace-nowrap flex-shrink-0">{p.users_count}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Quick Stats */}
      <div className="bg-white border border-gray-100 shadow-sm p-4">
        <h3 className="text-xs font-bold text-gray-900 uppercase tracking-wider mb-3">Quick Stats</h3>
        <div className="space-y-2.5">
          <div className="flex items-center justify-between">
            <span className="text-xs text-gray-500">Products Tracked</span>
            <span className="text-xs font-bold text-gray-900">{products.length}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-xs text-gray-500">Categories</span>
            <span className="text-xs font-bold text-gray-900">10</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-xs text-gray-500">Added This Month</span>
            <span className="text-xs font-bold text-gray-900">127</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-xs text-gray-500">Avg. Rating</span>
            <span className="text-xs font-bold text-gray-900 flex items-center gap-1">
              4.7 <i className="ri-star-fill text-amber-400 text-[10px]"></i>
            </span>
          </div>
        </div>
      </div>

      {/* Categories Breakdown */}
      <div className="bg-white border border-gray-100 shadow-sm p-4">
        <h3 className="text-xs font-bold text-gray-900 uppercase tracking-wider mb-3">Top Categories</h3>
        <div className="space-y-2">
          {[
            { name: 'LLM Tools', count: 312, pct: 75 },
            { name: 'Code Assistants', count: 198, pct: 55 },
            { name: 'Image Generation', count: 176, pct: 48 },
            { name: 'AI Agents', count: 154, pct: 40 },
            { name: 'Voice & Audio', count: 121, pct: 32 },
          ].map(cat => (
            <div key={cat.name}>
              <div className="flex items-center justify-between mb-1">
                <span className="text-[11px] text-gray-600">{cat.name}</span>
                <span className="text-[10px] text-gray-400">{cat.count}</span>
              </div>
              <div className="w-full h-1.5 bg-gray-100 overflow-hidden">
                <div className="h-full bg-[#0A0A0A]" style={{ width: `${cat.pct}%` }}></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
